// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1ny1P","file":"styles_file__1Rpy3"};